import { alertStatusOptions, alertTypeOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { StatusOfAlert } from "components/table/columnComponents/StatusOfAlert"

export const vendorAlertsTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "",
    name: "checkbox",
    type: "checkbox",
    size: "mini",
    cellComponent: "checkbox",
  },
  {
    title: "Alerts",
    type: "select",
    name: "type",
    options: alertTypeOptions,
  },
  {
    title: "Date",
    type: "sort-date",
    name: "date",
  },
  {
    title: "Device S/N",
    type: "sort-search",
    name: "sn",
  },
  {
    title: "Status",
    type: "select",
    name: "status",
    options: alertStatusOptions,
    cellComponent: StatusOfAlert,
  },
  {
    title: "Full Name",
    type: "sort-search",
    name: "full_name",
  },
  {
    title: "Phone Number",
    type: "sort-search",
    name: "phone_number",
  },
  {
    title: "Email",
    type: "sort-search",
    name: "email",
  },
  {
    title: "Device Location",
    type: "sort-search",
    name: "location",
  },
  {
    title: "Country",
    type: "sort-search",
    name: "country",
  },
  {
    title: "Address",
    type: "sort-search",
    name: "address1",
  },
  {
    title: "City",
    type: "sort-search",
    name: "city",
  },
  {
    title: "State",
    type: "sort-search",
    name: "state",
  },
]
